import React from 'react';
import {Page, Text, Font, Image, Document, StyleSheet, PDFViewer} from '@react-pdf/renderer';
import Title from "antd/es/typography/Title";


const PdfView = () => {

  const [_lsUser, setLsUser] = React.useState({});

  React.useEffect(() => {

    let mounted = true;

    if (mounted) {
      setLsUser(JSON.parse(localStorage.getItem('usuario')))
    }
    return () => {
      mounted = false
    };

  }, [])

  const {idDoc, nombre, apellidos} = _lsUser;

  const textQr = `${idDoc} - ${nombre} ${apellidos} - XXII Simposio Internacional de Nogal Pecanero 2021.`;

  const urlQr = `https://chart.googleapis.com/chart?cht=qr&chl=${textQr}&chs=480x480&choe=UTF-8&chld=L|2%27`;

  return (<>
    <Title level={4} style={{textAlign:"right", color:"red"}}>El periodo de generación de constancia es limitado.</Title>
    <PDFViewer style={{width: '100%', height: '100vh'}}>
      <Document>
        <Page orientation="landscape" style={styles.body}>
          <Text style={styles.subtitle}>{nombre} {apellidos}</Text>


          <Image
            style={styles.image}
            src="/reconocimientoXXIII.png"
          />
        </Page>
      </Document>
    </PDFViewer>
  </>
  )
}

Font.register({
  family: 'Oswald',
  src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 15,
    paddingBottom: 65,
    paddingHorizontal: 35,
    backgroundImage: "url(/reconocimientoXXIII.png)"
  },
  title: {
    fontSize: 54,
    textAlign: 'center',
    fontFamily: 'Oswald',
    color: '#333',
    fontWeight: 'bold',
  },

  subtitle: {
    position: 'absolute',
    fontSize: 28,
    textTransform: 'capitalize',
    fontFamily: 'Oswald',
    marginTop: "290px",
    marginLeft:"300px",
    width:"500px",
    textAlign:'center'
  },
  desc: {
    fontSize: 17,
    textAlign: 'center',
  },
  image: {
    zIndex: '9',
    marginTop: "-15px",
    marginLeft: "-50px",
    marginBottom: "-70px",
    marginRight: "-50px",
    width: "112%",
  },
  qrCode: {
    top: -10,
    left: 650,
    width: 100,
    marginTop: "290px",
  }
});
export default PdfView
